// src/pages/OtpPage.jsx
import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { verifyOtp } from "../API/axiosClient";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
// import JanhitChemist from "../image/Janhit Chemist.png";
import finallogo from "../image/finallogo.png";
// import Group from "../image/Group.png";
import { discount2 } from "../imgUrl";

const OtpPage = () => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string()
        .length(6, "OTP must be 6 digits")
        .required("OTP is required"),
    }),

    onSubmit: async (values, { setSubmitting }) => {
      try {
        // Call the OTP verification API
        const response = await verifyOtp(values.otp);

        if (!response.error) {
          toast.success("OTP verified successfully!");
          // Navigate to the password reset page with the token as a query parameter
          navigate(`/reset-password?token=${response.token}`);
        } else {
          toast.error("Invalid OTP. Please try again.");
        }
      } catch (error) {
        toast.error(
          "An error occurred during OTP verification. Please try again."
        );
        console.error("Error during OTP verification:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      <div className="brand-logo">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 col-xs-12">
              <div className="brand-logo-main text-center">
                <img src={finallogo} alt="Brand Logo" className="logo-login" />
              </div>
            </div>
            <div className="col-lg-7 col-md-7 col-sm-7 col-12 col-xs-12 text-center weltezt">
              <img
                src={discount2}
                alt="Discount Banner"
                width="400"
                height="400"
              />
              <h5>Welcome to Janhit Chemist</h5>
              <p>
                Sign up with us and get exclusive discounts and saving on
                medicines. Get express delivery in 2 hours.
              </p>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-5 col-12 col-xs-12">
              <div className="from-section">
                <h5 className="text-center">Enter OTP</h5>
                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        formik.touched.otp && formik.errors.otp
                          ? "is-invalid"
                          : ""
                      }`}
                      name="otp"
                      placeholder="Enter 6-digit OTP"
                      value={formik.values.otp}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.otp && formik.errors.otp ? (
                      <div className="invalid-feedback">
                        {formik.errors.otp}
                      </div>
                    ) : null}
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={formik.isSubmitting}
                  >
                    Verify OTP
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtpPage;
